<template>
    <div class="comms-brief-container">
        <div class="header">
            <div class="header-txt">The Brief</div>
            <p class="pr-type-name" :class="typeName">{{ prTypeName }}</p>
        </div>
        <v-form class="comms-form" v-model="isFormValid" @submit.prevent v-if="staticQuestion">
            <div class="grid-container">
                <div v-for="(ques, index) in coreDetailsQuestions" :key="index" class="grid-item">
                    <div class="label-info">{{ ques.questionText }} <span v-if="ques.isRequired"
                            class="required">*</span></div>
                    <div class="input-container">
                        <v-text-field class="text-box" v-model="ques.answer" :rules="ques.isRequired ? fieldRules : []"
                            :placeholder="ques.placeholderText" variant="plain" density="compact"
                            v-if="ques.responseType === 'text'"></v-text-field>
                        <v-menu v-if="ques.responseType === 'date'" v-model="ques.showDateMenu"
                            :close-on-content-click="false">
                            <template v-slot:activator="{ on, props }">
                                <div class="selected-date-container">
                                    <v-text-field v-model="ques.displayDateVariable" :placeholder="ques.placeholderText"
                                        readonly variant="plain" density="compact" v-on="on" v-bind="props" hide-details
                                        :rules="ques.isRequired ? fieldRules : []" class="text-box">
                                        <template #append-inner>
                                            <img :src="require('@/assets/icons/calendar.svg')" alt="">
                                        </template>
                                    </v-text-field>
                                </div>
                            </template>
                            <v-date-picker v-model="ques.answer" show-adjacent-months :min="new Date()"
                                @update:model-value="(value) => updateDate(value, ques)"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
            </div>
            <div class="form-label" v-if="staticQuestion.questions && staticQuestion.questions.length > 0">
                <div class="input-wrapper" v-for="(ques, index) in staticQuestion.questions" :key="index">
                    <div class="form-label" v-if="ques.quoteDetails">
                        <div class="form-input">
                            <div class="label-wrapper">
                                <div class="label">Spokesperson & Quote</div>
                            </div>

                            <div v-for="(quote, index) in ques.quoteDetails" class="quote-container">
                                <!-- <div class="feature-header">
                                    <div class="label">Quote Title</div>
                                    <button @click="removeQuote(index, ques)" class="remove-feature">
                                        <img :src="require('@/assets/icons/remove.svg')"></img>
                                    </button>
                                </div> -->

                                <div class="feature-details">
                                    <div class="form-input">
                                        <v-textarea v-model="quote.quoteDetails" placeholder="Name, title, quote "
                                            variant="outlined" density="compact"></v-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="add-feature" v-if="ques.quoteDetails.length < 5" @click="addQuote(ques)">
                            <Svg :src="require('@/assets/icons/add.svg')" fill="black"></Svg>
                            New Quote
                        </div> -->
                    </div>
                    <div class="form-label" v-else-if="ques.dynamicFeatures">
                        <div class="form-input">
                            <div class="label-wrapper">
                                <div class="label">Features, Specs</div>
                            </div>

                            <div v-for="(feature, index) in ques.dynamicFeatures" class="feature-container">
                                <div class="feature-header">
                                    <div class="label"></div>
                                    <button @click="removeFeature(index, ques)" class="remove-feature">
                                        <img :src="require('@/assets/icons/remove.svg')"></img>
                                    </button>
                                </div>

                                <div class="feature-details">
                                    <div class="form-input">
                                        <v-text-field v-model="feature.name" placeholder="Feature Name"
                                            variant="outlined" density="compact"></v-text-field>
                                    </div>
                                    <div class="form-input">
                                        <v-textarea v-model="feature.description"
                                            placeholder="Describe the features, benefits and any proof to backup your claims"
                                            variant="outlined" density="compact"></v-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-feature" v-if="ques.dynamicFeatures.length < 5" @click="addFeature(ques)">
                            <Svg :src="require('@/assets/icons/add.svg')" stroke="black"></Svg>
                            New feature
                        </div>
                    </div>
                    <div v-else class="form-input">
                        <div class="label">{{ ques.questionText }} <span v-if="ques.isRequired"
                                class="required">*</span></div>
                        <v-text-field v-model="ques.answer" :rules="ques.isRequired ? fieldRules : []"
                            :placeholder="ques.placeholderText || 'Give a short overview'" variant="outlined"
                            density="compact" v-if="ques.responseType === 'text'"></v-text-field>
                        <v-select v-else-if="ques.responseType === 'dropdown'" v-model="ques.answer"
                            :rules="ques.isRequired ? fieldRules : []" placeholder="Select an option"
                            :items="ques.dropDownKey || []" variant="outlined" density="compact" />

                        <v-textarea v-model="ques.answer" :rules="ques.isRequired ? fieldRules : []"
                            :placeholder="ques.placeholderText || 'Give a short overview'" variant="outlined"
                            density="compact" v-else-if="ques.responseType === 'textarea'"></v-textarea>
                        <v-menu v-model="ques.showDateMenu" :close-on-content-click="false" v-else>
                            <template v-slot:activator="{ on, props }">
                                <div class="selected-date-container">
                                    <v-text-field v-model="ques.displayDateVariable" placeholder="Pick a date" readonly
                                        variant="outlined" density="compact" v-on="on" v-bind="props"
                                        :rules="ques.isRequired ? fieldRules : []" class="date-field">
                                        <template #append-inner>
                                            <img :src="require('@/assets/icons/calendar.svg')" alt="">
                                        </template>
                                    </v-text-field>
                                </div>
                            </template>
                            <v-date-picker v-model="ques.answer" show-adjacent-months :min="new Date()"
                                @update:model-value="(value) => updateDate(value, ques)"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
            </div>


        </v-form>
    </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
    props: {
        modelValue: {
            type: Object
        },
        coreDetailsQuestions: {
            type: Array
        },
        prTypeName: {
            type: String
        }
    },
    data() {
        return {
            isFormValid: false,
            fieldRules: [
                (v) => !!v || 'This field is required'
            ],
            isQuoteDetails: null,
            typeName: null
        }
    },
    computed: {
        staticQuestion: {
            get() {
                this.typeName = (this.prTypeName ?? '')
                    .split(' ')
                    .join('-')
                    .toLowerCase()
                return this.modelValue;
            }
        }
    },
    watch: {
        staticQuestion: {
            deep: true,
            handler(newValue) {
                this.$emit('update:modelValue', newValue);
            }
        },
        isFormValid() {
            this.$emit('update:isFormValid', this.isFormValid);
        },
        coreDetailsQuestions: {
            deep: true,
            handler(newValue) {
                this.$emit('update:coreDetailsQuestions', newValue);
            }
        }
    },
    methods: {
        updateDate(date, ques) {
            ques.displayDateVariable = moment(date).format('DD-MM-YYYY');
            ques.showDateMenu = false;
        },

        addFeature(question) {
            if (question.dynamicFeatures.length < 5) {
                question.dynamicFeatures.push({
                    name: null,
                    description: null,
                    userBenefits: null,
                    supportEvidence: null,
                });
            }
        },

        removeFeature(index, question) {
            question.dynamicFeatures.splice(index, 1);
        },

        addQuote(question) {
            question.quoteDetails.push({
                name: null,
                titleCompany: null,
                preference: null,
            });
        },

        removeQuote(index, question) {
            question.quoteDetails.splice(index, 1);
        },
    },
}
</script>

<style scoped>
.comms-brief-container {
    width: 100%;
    max-width: 1024px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 24px 8px 40px 8px;
}

.header {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
}

.header-txt {
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    color: #FAFAFA;
    font-family: monospace;
}


.pr-type-name {
    display: flex;
    align-items: center;
    border-radius: 4px;
    padding: 1px 16px;
    width: fit-content;
    ;
    justify-content: center;
    align-items: center;
}

.pr-type-name.general {
    color: #33AC37;
    background: #ECFFEC;
    border: 1px solid #D1F5D3;
}

.pr-type-name.product-launch {
    color: #0095FF;
    background-color: #F0F9FF;
    border: 1px solid #E3F2FF;
}

.pr-type-name.event-announcement {
    color: #FF27DE;
    background-color: #FFF0FD;
    border: 1px solid #FFE3FD;
}

.pr-type-name.funding\/m\&a {
    color: #FF900A;
    background: #FFF9EC;
    border: 1px solid #FFF3D3;
}

.comms-form {
    display: flex;
    flex-direction: column;
    padding: 40px;
    gap: 40px;
    border-radius: 24px;
    background: #FAFAFA;
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* 2 columns in each row */
    gap: 16px;
    /* space between grid items */
}

.grid-item {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    /* align-items: center; */
}

.input-container {
    width: 270px;
}

.text-box :deep(.v-field--no-label input, .v-text-field .v-field--active input) {
    padding: 0px !important;
    font-size: 16px;
}

.form-label {
    display: flex;
    flex-direction: column;
    gap: 1em;
}

.form-title {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    color: #A3A3A3;
}

.form-input {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.label {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #171717;
}

.label-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.label-info {
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    color: #A3A3A3;
    padding-top: 6px;
}

.feature-container {
    display: flex;
    flex-direction: column;
    gap: 1em;
    background-color: #F5F5F5;
    padding: 1em;
    border-radius: 8px;
}

.feature-container .form-input :deep(.v-text-field input),
.feature-container .form-input :deep(.v-textarea textarea, .v-textarea) {
    background-color: white;
    border-radius: 8px;
}

.quote-container {
    display: flex;
    flex-direction: column;
    gap: 1em;
    /* background-color: #F5F5F5;
    padding: 1em; */
    border-radius: 8px;
}

.quote-container .form-input :deep(.v-text-field input),
.quote-container .form-input :deep(.v-textarea textarea, .v-textarea) {
    /* background-color: white; */
    border-radius: 8px;
}

.feature-header {
    display: flex;
    justify-content: space-between;
}

.feature-details {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
}

.add-feature {
    display: flex;
    gap: 8px;
    align-items: center;
    border: 2px dashed #ccc;
    padding: 10px;
    text-align: left;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-bottom: 1em;
}

.remove-feature {
    cursor: pointer;
}

.remove-feature img {
    width: 25px;
    height: 25px;
}

.error-message {
    color: red;
    font-size: 14px;
}

.date-field :deep(input:hover) {
    cursor: pointer !important;
}

.text-box :deep(input:hover) {
    cursor: pointer !important;
}
</style>